import { render, staticRenderFns } from "./AlertsModal.vue?vue&type=template&id=e2be9e30&"
import script from "./AlertsModal.vue?vue&type=script&lang=js&"
export * from "./AlertsModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports